import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import FlowerContainer from '../../../../sales-conversation/src/components/intro/FlowerContainer';
import { VStack } from '@wegroup/design-system';
import { useParams } from 'react-router';
import SelectionViewWrapper from '../../components/selection/SelectionViewWrapper';

// Views
import FlowSelection from './flow-selection';
import SubjectSelection from './subject-selection';

const Selection: React.FC<React.PropsWithChildren<unknown>> = () => {
  /**
   * Importing theme from styled components to support "isImmo" check
   */
  const theme = useContext(ThemeContext);
  const { page } = useParams<{ page: string }>();
  return (
    <VStack
      justifyContent={{ base: 'flex-start', mobileL: 'center' }}
      boxShadow="level1"
      width="100%"
      height="100%"
      overflow="hidden"
      bgColor={theme['isImmo'] ? '#f4f4f4' : theme.secondary[800]}
    >
      <FlowerContainer noPadding maxWidth="1200px">
        {{
          'flow-selection': <FlowSelection />,
          'subject-selection': <SubjectSelection />,
        }[page] || <SelectionViewWrapper question="no view was found" />}
      </FlowerContainer>
    </VStack>
  );
};

export default Selection;
